// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QHaHo","type":"styles_type__lXqse","choices":"styles_choices__1B1Qv"};